import styled, { css, keyframes } from "styled-components";

const YELLOW = "#ffd60a";
const DARK = "#1b262e";

// Soft pulse, not a flash: the dispatcher sees the header all day.
const pulse = keyframes`
	0%, 100% { box-shadow: 0 0 0 0 rgba(255, 214, 10, 0.75); filter: brightness(1); }
	50% { box-shadow: 0 0 0 6px rgba(255, 214, 10, 0); filter: brightness(1.12); }
`;

const noticeBox = css`
	display: flex;
	align-items: center;
	gap: 12px;

	/* A narrow header cell squeezes the text, never the right-hand buttons. */
	min-width: 0;
	overflow: hidden;

	padding: 4px 6px 4px 14px;
	border-radius: 6px;

	background: ${YELLOW};
	color: ${DARK};

	font-family: Lato;
	font-size: 16px;
	font-weight: 700;
	line-height: 20px;
	white-space: nowrap;

	animation: ${pulse} 1.5s ease-in-out infinite;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;

export const NoticeBox = styled.div`
	${noticeBox}
`;

export const NoticeText = styled.span`
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const ReloadButton = styled.button`
	flex-shrink: 0;

	padding: 4px 12px;
	border: none;
	border-radius: 4px;

	background: ${DARK};
	color: ${YELLOW};

	font-family: Lato;
	font-size: 14px;
	font-weight: 700;
	line-height: 18px;

	cursor: pointer;

	&:hover {
		background: #000;
	}
`;

export const reload = () => {
	window.location.reload();
};
